<template>
    <div class="mb-3 border py-3 alert-success">
        <div class="container-fluid chat_container">
            <Video 
                :username="username" 
                :sala="sala" 
                :direto="direto" 
                :token="token" 
                :master="master"
                :telefone="telefone"
                :block_gravar="block_gravar"
                :atendimento="atendimento" />
        </div>
    </div>
</template>

<script>
import Video from './Video'

export default {
    data () { 
        return { 
            username: this.direto ? ( this.nome ? this.nome : 'Paciente' ) : this.$store.state.user.st_login,
            authenticated: true, 
        }
    },

    components: {
        Video,
    },

    props: ['nome', 'sala', 'direto', 'token', 'master', 'telefone', 'atendimento', 'block_gravar'],

    methods: { 

        submitUsername(username) {
            if(!username) {
                return alert('please provide a username');
            }

            this.username = username;
            this.authenticated = true;
        },
  
    },

}
</script>

<style scoped>
 #app1 {
   font-family: 'Avenir', Helvetica, Arial, sans-serif;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
   text-align: center;
   color: #2c3e50;
   margin-top: 60px;
   background: #2c3e50;
 }

 .box {
   border: 1px solid gray;
 }

 .username {
   margin: 12px auto 7px auto;
   color: wheat;
 }

 .Botton {
   color: #fff;
   background-color: #4d555f;
   border-color: #303840;
   padding: 8px;
   font-weight: bolder;
 }
</style>